import { Dialog, DialogContent } from '@mui/material'

import withStyles from '@mui/styles/withStyles'

const StyledDialog = withStyles((theme) => ({
    paper: {
        borderRadius: 15,
        minHeight: '200px',
    },
}))(Dialog)

export const FullscreenDialog = withStyles((theme) => ({
    paper: {
        borderRadius: 15,
        margin: 10,
        width: '100%',
        height: '95vh',
        '& .MuiDialogContent-root:first-child': {
            padding: 0,
        },
    },
}))(Dialog)

export const FullscreenDialogContent = withStyles((theme) => ({
    root: {
        padding: 0,
    },
}))(DialogContent)

export default StyledDialog
